import React from 'react'
import ActionButton from '../buttons/ActionButton'
import classnames from 'classnames'

const Submit = ({ disabled, className, ...props }) => {
  const classes = classnames(
    'btn btn--bold btn--submit',
    className
  );

  return (
    <ActionButton
      type="submit"
      className={classes}
      disabled={disabled}
      {...props}
    />
  );
};

export default Submit
